export const SubtaskTypeEnum = {
  DOCUMENT: 'DOCUMENT',
  LINK: 'LINK',
} as const;
